angular.module('admin')
  .controller('StartCtrl', ['$scope', '$state','AccountService', 'AuthForwarder', 'SessionService', 'AuthResolver', 'FEATURES',
  function($scope, $state, AccountService, AuthForwarder, SessionService, AuthResolver, FEATURES){

    $scope.accountService = AccountService;

    $scope.setGARole = function(){
      if($scope.accountService.hasFeature(FEATURES.ADMIN)) {
        ga('set', 'dimension1', 'admin');
      } else {
        ga('set', 'dimension1', 'agent');
      }
    };

    $scope.startUser = function(){
      $scope.setGARole();
      $scope.accountService.initIntercom();
      AuthForwarder.forwardAfterLogin();
    };


    const jwtPayload = SessionService.extractJWT();

    if(jwtPayload) {
      AuthResolver.identifyUser()
        .then((user) => {
          $scope.startUser();
        }).catch(function(err){
          $state.go('login');
        });
    } else if(SessionService.isLoggedIn()){ // Support users with old login (remove at some point)
      $scope.startUser();
    } else {
      $state.go('login');
    }

  }]);
